var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Layout__wrapper"},[_c('Navbar'),_c('MobileNavbar'),_c('b-container',{staticClass:"Layout__container mb-3"},[_vm._t("default")],2),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }